import { yzsComHttp as http, httpClient } from './_http';

const prifix = () => {
    return window.env.message;
};
const getVcode = () => {
    return http.get(prifix() + '/msg/captcha/image' + `?_ts=${Date.now()}`, {});
};
const checkVcode = (v, mateCode = 'YAZUISHOU') => {
    return http.post(prifix() + '/msg/captcha/sms', {
    // return http.post(prifix() + '/gw/message-center/msg/captcha/sms', {
        meta: {
            code: mateCode,
            client: 'PC',
            tag: 'default',
            time: Date.now().valueOf()
        },
        params: v
    });
};

export const convCompanyNameToSimple = (companyName = '') => {
    return httpClient.get('/duckBill/convertToSimple/CompanyName', {
        params: {
            companyName
        }
    });
};

export const api = {
    getVcode, checkVcode
};



// WEBPACK FOOTER //
// ./src/api/register.js